<template>
  <div class="pb_content">
    <div class="pb_content_body" style="height: 100%">
      <div class="body_student">
        <div class="student_head">
          <div v-if="screenType != 2" class="return" @click.stop="
            goTo(
              '/index?userid=' +
              userid +
              '&oid=' +
              oid +
              '&org=' +
              org +
              '&cid=' +
              classId +
              '&tType=' +
              tType +
              '&screenType=' +
              screenType
            )
          ">
            返回
            <!-- <img src="../../assets/icon/return.png" alt="" /> -->
          </div>
          <div class="box_course">
            <div class="wheel">
              <img style="object-fit: cover" :src="
                this.courseDetail.cover != null &&
                  this.courseDetail.cover != ''
                  ? JSON.parse(this.courseDetail.cover).length > 0
                    ? JSON.parse(this.courseDetail.cover)[0].url
                    : mr
                  : mr
              " alt />
            </div>
            <div class="right_box">
              <div class="rightT">
                <div class="right_box_title">{{ courseDetail.title }}</div>
                <div class="jd">{{ chapInfo.length }}阶段</div>
                <div class="jd">{{ rw }}任务</div>
              </div>
              <div class="cType">
                <div class="all_choose" v-for="(item, index) in courseType" :key="index">
                  <span style="color: #6c6c6c">{{ item + ":" }}</span>
                  <span class="type_children" v-for="(item2, index2) in courseTypeJson[item]" :key="index2">{{ item2
                  }}</span>
                </div>
              </div>
              <div class="cType" style="font-size: 18px; color: #6c6c6c; align-items: flex-start">
                <div style="min-width: 150px">
                  创建者：<span style="color: #000">{{
                    courseDetail.username
                  }}</span>
                </div>
                <div class="Tname" v-if="Tname.length > 0" style="margin-left: 32px" @click="TnameCheck = !TnameCheck">
                  协同人员：<span v-for="(tname, tIndex) in TnameCheck ? Tname : Tname.slice(0, 6)" :key="tIndex"
                    style="margin: 0 5px; color: #000">{{ tname }}</span><span style="margin: 0 5px; color: #b2b2b2"
                    v-if="!TnameCheck && Tname.length > 6">更多....</span>
                </div>
              </div>
              <div class="cType" style="font-size: 18px; color: #6c6c6c">
                <div style="display: flex; align-items: center">
                  <div>参与人数：</div>
                  <div class="man">
                    <img src="../../assets/people.png" alt />
                  </div>
                  <div class="person" style="color: #000">
                    {{
                      courseDetail.vcount != null ? courseDetail.vcount : 0
                    }}人
                  </div>
                </div>
              </div>
              <div class="cType" style="font-size: 18px; color: #6c6c6c" v-if="classList.length && tType != 2">
                <div>
                  授课班级:<el-button @click="gotoCourse('')"
                    style="background: #4a9eed; color: #fff; margin: 0 5px">全部</el-button><el-button
                    @click="gotoCourse(item.id)" v-for="(item, index) in classList" :key="index"
                    style="background: #4a9eed; color: #fff; margin: 0 5px">{{ item.name }}</el-button>
                </div>
              </div>
              <div class="btnBox">
                <!-- <div class="now_study" @click="dialogVisible = true">
                  立即学习
                </div> -->
              <!-- <div class="now_study" @click="dialogVisibleGroup = true">
                 {{courseDetail.userid != userid ? '加入分组' : '设置分组'}}
              </div> -->
            </div>
            </div>
          </div>
        </div>
        <div class="student_body">
          <div class="sLeft" v-if="courseDetail.brief">
            <div class="courseT">项目详情</div>
            <div class="courseTd">{{ courseDetail.brief }}</div>
          </div>
          <div :class="courseDetail.brief != '' ? 'rightTd' : 'noBRight'">
            <div v-if="tType == 1 || tType == 4" class="checkBox">
              <span :class="{ active: type == 2 }" @click="type = 2">阶段选择</span>
              <span :class="{ active: type == 1 }" @click="getCTwo">课程分析</span>
            </div>
            <div v-if="((tType == 1 || tType == 4) && type == 2) || tType == 2"
              :class="courseDetail.brief != '' ? 'rightTd' : 'noBRight'" style="width: 100%">
              <div class="blue_box_one" v-for="(item, index) in chapInfo" :key="index" @click="addUserRate(index)">
                <div>第{{ index + 1 }}阶段</div>
                <div :title="item.dyName">{{ item.dyName }}</div>
                <div>{{ item.chapterInfo[0].taskJson.length }}个任务</div>
              </div>
            </div>
            <div v-if="
              (tType == 1 || tType == 4) &&
              Object.keys(chaptersJson).length &&
              type == 1
            " class="detail">
              <div class="detail_box">
                <div class="title">
                  <span class="toolIcon">工具分析</span>
                  <div class="statebox">
                    <div>
                      <span class="taskIcon">全部阶段:</span><span>{{ chaptersJson.state.stage }}</span>
                    </div>
                    <div>
                      <span class="finishIcon">已进行:</span><span>{{ chaptersJson.state.finish }}</span>
                    </div>
                    <div>
                      <span class="learningIcon">未进行:</span><span>{{ chaptersJson.state.learing }}</span>
                    </div>
                  </div>
                </div>
                <div class="box" v-if="chaptersJson.tool.length">
                  <div class="progress">
                    <div v-for="(item, index) in chaptersJson.tool" :key="index" class="chapter">
                      <div class="stage stageCss" :style="{
                        width:
                          item.array.length * 180 +
                          (item.array.length - 1) * 10 +
                          'px',
                      }" @click="addUserRate(index)">
                        <div style="
                              width: 100%;
                              display: flex;
                              justify-content: center;
                            ">
                          <el-tooltip class="item" effect="light" :content="item.name" placement="top">
                            <div class="titleCss" style="width: 80%; max-width: unset">
                              第{{ index + 1 }}阶段 {{ item.name }}
                            </div>
                          </el-tooltip>
                        </div>
                      </div>

                      <!-- {{ chaptersJson.chapterState[index].isFinsh ? '已完成' : '进行中' }} -->
                      <div class="task">
                        <div v-for="(item2, index2) in item.array" :key="index + '-' + index2" class="taskBox">
                          <div class="taskName">
                            <div class="navIndex">任务{{ index2 + 1 }}</div>
                            <div>
                              <el-tooltip class="item" effect="light" :content="item2.name" placement="top">
                                <div class="titleCss">{{ item2.name }}</div>
                              </el-tooltip>
                            </div>
                          </div>
                          <div class="p_tool_box">
                            <span v-for="(item3, index3) in item2.array" :key="index + '-' + index2 + '-' + index3"
                              class="p_tool">
                              <div v-if="item3.tool == 1">
                                <img src="../../assets/icon/secondToolList/whiteBoard.png" alt />
                                <div>电子白板</div>
                              </div>
                              <div v-if="item3.tool == 3">
                                <img src="../../assets/icon/secondToolList/mindMapping.png" alt />
                                <div>思维导图</div>
                              </div>
                              <div v-if="item3.tool == 6">
                                <img src="../../assets/icon/secondToolList/doc.png" alt />
                                <div>协同文档</div>
                              </div>
                              <div v-if="item3.tool == 7">
                                <img src="../../assets/icon/secondToolList/mindNetwork.png" alt />
                                <div>思维网格</div>
                              </div>
                              <div v-if="item3.tool == 8">
                                <img src="../../assets/icon/secondToolList/library.png" alt />
                                <div>素材库</div>
                              </div>
                              <div v-if="item3.tool == 17">
                                <img src="../../assets/icon/secondToolList/library.png" alt />
                                <div>学习资料</div>
                              </div>
                              <div v-if="item3.tool == 2">
                                <img src="../../assets/icon/secondToolList/note.png" alt />
                                <div>便签</div>
                              </div>
                              <div v-if="item3.tool == 4">
                                <img src="../../assets/icon/thirdToolList/ask.png" alt />
                                <div>问卷调查</div>
                              </div>
                              <div v-if="item3.tool == 45">
                                <img src="../../assets/icon/thirdToolList/choose.png" alt />
                                <div>选择题</div>
                              </div>
                              <!-- <div v-if="item3.tool == 5">
                            <img
                              
                              src="../../assets/icon/thirdToolList/score.png"
                              alt
                            />
                            <div >量规评分</div>
                          </div> -->
                              <div v-if="item3.tool == 10">
                                <img src="../../assets/icon/thirdToolList/time.png" alt />
                                <div>倒计时</div>
                              </div>
                              <div v-if="item3.tool == 15">
                                <img src="../../assets/icon/thirdToolList/answer.png" alt />
                                <div>问答工具</div>
                              </div>
                              <div v-if="item3.tool == 26">
                                <img src="../../assets/icon/thirdToolList/courseDesign.png" alt />
                                <div>课程设计</div>
                              </div>
                              <div v-if="item3.tool == 18">
                                <img src="../../assets/icon/thirdToolList/trainPlatform.png" alt />
                                <div>训练服务器</div>
                              </div>
                              <div v-if="item3.tool == 16">
                                <img src="../../assets/icon/thirdToolList/work.png" alt />
                                <div>作业提交</div>
                              </div>
                              <div v-if="item3.tool == 21">
                                <img src="../../assets/icon/fourthToolList/program.png" alt />
                                <div>编程平台</div>
                              </div>
                              <div v-if="item3.tool == 22">
                                <img src="../../assets/icon/fourthToolList/program.png" alt />
                                <div>AI体验</div>
                              </div>
                              <div v-if="item3.tool == 23">
                                <img src="../../assets/icon/fourthToolList/program.png" alt />
                                <div>Python</div>
                              </div>
                              <div v-if="item3.tool == 24">
                                <img src="../../assets/icon/fourthToolList/AIprogram.png" alt />
                                <div>AI平台</div>
                              </div>
                              <div v-if="item3.tool == 25">
                                <img src="../../assets/icon/thirdToolList/evalua.png" alt />
                                <div>目标管理</div>
                              </div>
                              <div v-if="item3.tool == 31">
                                <img src="../../assets/icon/secondToolList/networkPanel.png" alt />
                                <div>数学画板</div>
                              </div>
                              <div v-if="item3.tool == 28">
                                <img src="../../assets/icon/secondToolList/translation.png" alt />
                                <div>翻译</div>
                              </div>
                              <div v-if="item3.tool == 37">
                                <img src="../../assets/icon/secondToolList/mohe.png" alt />
                                <div>魔盒识字</div>
                              </div>
                              <div v-if="item3.tool == 38">
                                <img src="../../assets/icon/secondToolList/24game.png" alt />
                                <div>24点</div>
                              </div>
                              <div v-if="item3.tool == 39">
                                <img src="../../assets/icon/secondToolList/GeoGebra.png" alt />
                                <div>GeoGebra</div>
                              </div>
                              <div v-if="item3.tool == 32">
                                <img src="../../assets/icon/thirdToolList/code.png" alt />
                                <div>源码编辑</div>
                              </div>
                              <div v-if="item3.tool == 40">
                                <img src="../../assets/icon/secondToolList/eval.png" alt />
                                <div>学生评价</div>
                              </div>
                              <div v-if="item3.tool == 41">
                                <img src="../../assets/icon/thirdToolList/select.png" alt />
                                <div>选择填空</div>
                              </div>
                              <div v-if="item3.tool == 44">
                                <img src="../../assets/icon/thirdToolList/hanClass.png" alt />
                                <div>汉字宫</div>
                              </div>
                              <div v-if="item3.tool == 47">
                                <img src="../../assets/icon/fourthToolList/conSentences.png" alt />
                                <div>连词成句</div>
                              </div>
                              <div v-if="item3.tool == 48">
                                <img src="../../assets/icon/fourthToolList/table.png" alt />
                                <div>表格</div>
                              </div>
                              <div v-if="item3.tool == 49">
                                <img src="../../assets/icon/fourthToolList/group.png" alt />
                                <div>学生分组</div>
                              </div>
                              <div v-if="item3.tool == 50">
                                <img src="../../assets/icon/thirdToolList/plwork.png" alt />
                                <div>批量上传</div>
                              </div>
                              <div v-if="item3.tool == 57">
                                <img src="../../assets/icon/fourthToolList/cocopi.png" alt />
                                <div>CocoPi</div>
                              </div>
                              <div v-if="item3.tool == 58">
                                <img src="../../assets/icon/fourthToolList/car.png"
                                  alt />
                                <div>模拟驾驶</div>
                              </div>
                              <div v-if="item3.tool == 59">
                                <img src="../../assets/icon/fourthToolList/lineSearch.png" alt />
                                <div>路径搜索</div>
                              </div>
                              <div v-if="item3.tool == 60">
                                <img src="../../assets/icon/fourthToolList/deepLearning.png" alt />
                                <div>深度学习</div>
                              </div>
                              <div v-if="item3.tool == undefined">
                                <img src="../../assets/icon/empytool.png" alt style="width: 64px; height: 75px" />
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="detail_box" v-if="Object.keys(chaptersJson.time).length">
                <div class="title">
                  <span class="frequencyIcon">活跃频率</span>
                </div>
                <div class="box">
                  <div>
                    <Heatmap :Josn="chaptersJson.time" :num="chaptersJson.studentCount"></Heatmap>
                  </div>
                </div>
              </div>
              <div class="detail_box">
                <div class="title"><span class="timeIcon">实施时间</span></div>
                <div class="box">
                  <div style="font-size: 22px; margin: 15px 0 45px">
                    {{ courseDetail.title }}
                  </div>
                  <div class="chapter_time_box" style="margin-left: 170px">
                    <div v-for="(item, index) in chaptersJson.work" :key="index" class="c_box">
                      <div class="stage_box" style="left: -195px">
                        <div style="
                              min-width: 150px;
                              position: relative;
                              left: -5px;
                            ">
                          {{ item.time }}
                        </div>
                        <div class="yuan"></div>
                        <div class="stage">
                          第{{ index + 1 }}阶段 {{ item.name }}
                        </div>
                        <div class="s_up" :class="{ s_up2: !item.is }" @click="item.is = !item.is">
                          <img src="../../assets/icon/up.png" alt="" />
                        </div>
                      </div>
                      <div v-show="item.is">
                        <div v-for="(item2, index2) in item.chapter" :key="index + '-' + index2">
                          <div style="
                                display: flex;
                                flex-direction: row;
                                flex-wrap: nowrap;
                                align-items: center;
                              " v-if="
                                item2.task[0].tool != undefined && item2.isWork
                              ">
                            <div style="
                                  width: 13px;
                                  height: 13px;
                                  background: #5a82cb 100%;
                                  border-radius: 50%;
                                  margin-right: 10px;
                                "></div>
                            <div style="
                                  color: #4376c3;
                                  font-size: 20px;
                                  font-weight: bold;
                                ">
                              任务{{ index2 + 1 }}：{{ item2.name }}
                            </div>
                          </div>

                          <div class="p_tool_box2">
                            <span v-for="(item3, index3) in item2.task" :key="index + '-' + index2 + '-' + index3"
                              class="p_tool2">
                              <div class="toolBigBox" style="
                                    display: flex;
                                    flex-direction: row;
                                    flex-wrap: nowrap;
                                    align-items: center;
                                  " v-if="item3.works.length">
                                <div style="
                                      display: flex;
                                      flex-direction: row;
                                      flex-wrap: nowrap;
                                      align-items: flex-end;
                                      min-width: 140px;
                                    ">
                                  <div class="lineBox"></div>
                                  <div class="toolbox">
                                    <div style="font-size: 16px; font-weight: bold">
                                      步骤{{ index3 + 1 }}：
                                    </div>
                                    <div v-if="item3.tool == 1">电子白板</div>
                                    <div v-if="item3.tool == 3">思维导图</div>
                                    <div v-if="item3.tool == 6">协同文档</div>
                                    <div v-if="item3.tool == 7">思维网格</div>
                                    <div v-if="item3.tool == 8">素材库</div>
                                    <div v-if="item3.tool == 17">学习资料</div>
                                    <div v-if="item3.tool == 2">便签</div>
                                    <div v-if="item3.tool == 4">问卷调查</div>
                                    <div v-if="item3.tool == 45">选择题</div>
                                    <div v-if="item3.tool == 10">倒计时</div>
                                    <div v-if="item3.tool == 15">问答工具</div>
                                    <div v-if="item3.tool == 26">课程设计</div>
                                    <div v-if="item3.tool == 18">
                                      训练服务器
                                    </div>
                                    <div v-if="item3.tool == 16">作业提交</div>
                                    <div v-if="item3.tool == 21">编程平台</div>
                                    <div v-if="item3.tool == 22">AI体验</div>
                                    <div v-if="item3.tool == 23">Python</div>
                                    <div v-if="item3.tool == 24">AI平台</div>
                                    <div v-if="item3.tool == 25">目标管理</div>
                                    <div v-if="item3.tool == 31">数学画板</div>
                                    <div v-if="item3.tool == 28">翻译</div>
                                    <div v-if="item3.tool == 37">魔盒识字</div>
                                    <div v-if="item3.tool == 38">24点</div>
                                    <div v-if="item3.tool == 39">GeoGebra</div>
                                    <div v-if="item3.tool == 32">源码编辑</div>
                                    <div v-if="item3.tool == 40">学生评价</div>
                                    <div v-if="item3.tool == 41">选择填空</div>
                                    <div v-if="item3.tool == 44">汉字宫</div>
                                    <div v-if="item3.tool == 47">连词成句</div>
                                    <div v-if="item3.tool == 48">表格</div>
                                    <div v-if="item3.tool == 49">学生分组</div>
                                    <div v-if="item3.tool == 50">批量上传</div>
                                    <div v-if="item3.tool == 57">CocoPi</div>
                                    <div v-if="item3.tool == 58">模拟驾驶</div>
                                    <div v-if="item3.tool == 59">路径搜索</div>
                                    <div v-if="item3.tool == 60">深度学习</div>
                                  </div>
                                </div>
                                <div v-if="item3.works.length" style="
                                      display: flex;
                                      flex-direction: row;
                                      flex-wrap: wrap;
                                      align-items: center;
                                      margin-left: 10px;
                                    ">
                                  <!-- works:[],likeCount: 0, commentCount: 0, score: 0, isScore: 0  -->
                                  <div class="disCss">
                                    <div class="blueBtn">
                                      作业数量：{{ item3.works.length }}
                                    </div>
                                    <div v-if="chaptersJson.studentCount" class="blueBtn">
                                      任务完成率：{{
                                        (
                                          (item3.works.length /
                                            chaptersJson.studentCount) *
                                          100
                                        ).toFixed(2) > 100.0
                                        ? 100 + "%"
                                        : (
                                          (item3.works.length /
                                            chaptersJson.studentCount) *
                                          100
                                        ).toFixed(2) + "%"
                                      }}
                                    </div>
                                    <div class="blueBtn">
                                      <div>点赞：{{ item3.likeCount }}</div>
                                      <div style="margin-left: 15px">
                                        评论：{{ item3.commentCount }}
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="item3.isScore">
                                    <div class="disCss">
                                      <div class="blueBtn">
                                        作业评价量：{{ item3.isScore }}
                                      </div>
                                      <div class="blueBtn">
                                        评价平均分：{{
                                          (item3.score / item3.isScore).toFixed(
                                            2
                                          )
                                        }}分
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div v-for="(item, index) in Object.keys(chaptersJson.time)" :key="index">
                {{ '时间:' + item + '次数:' + chaptersJson.time[item] }}</div> -->
              <!-- <div>实施时间：{{ chaptersJson.startTime }}</div> -->
            </div>
          </div>
        </div>

        <!-- <div
          style="
            text-align: center;
            padding: 30px 0 20px 0;
            box-sizing: border-box;
          "
        >
          此处滚动加载..
        </div>-->
        <el-dialog title="阶段选择" :visible.sync="dialogVisible" :append-to-body="true" width="700px"
          :before-close="handleClose" class="dialog_change">
          <div style="font-size: 20px">请选择阶段</div>
          <div style="
                padding: 20px 30px;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
              ">
            <div class="blue_box" v-for="(item, index) in chapInfo" :key="index" @click="addUserRate(index)">
              <div>第{{ index + 1 }}阶段</div>
              <div>{{ item.dyName }}</div>
              <div>{{ item.chapterInfo[0].taskJson.length }}个任务</div>
            </div>
          </div>
        </el-dialog>
        <Group :dialogVisibleGroup.sync="dialogVisibleGroup" :classList="classList" :cid="id" :courseDetail="courseDetail" :userid="userid" :type="tType" :classId="classId"></Group>
      </div>
    </div>
  </div>
</template>

<script>
import Heatmap from "../tools/heatmap.vue";
import Group from "../group/group.vue"
export default {
  components: {
    Heatmap,
    Group
  },
  data() {
    return {
      choose: 0,
      dialogVisible: false,
      dialogVisibleGroup:false,
      id: this.$route.query.courseId,
      userid: this.$route.query.userid,
      oid: this.$route.query.oid,
      org: this.$route.query.org,
      classId: this.$route.query.cid,
      tType: this.$route.query.tType,
      screenType: this.$route.query.screenType,
      courseDetail: {},
      classList: [],
      aStudentName: [],
      chapInfo: [],
      courseType: [],
      Tname: [],
      TnameCheck: false,
      courseTypeJson: {},
      userinfo: [],
      mr: "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/noBanner1656409780264.jpg",
      rw: 0,
      chaptersJson: {},
      type: 2,
      inviteCode: []
    };
  },
  methods: {
    handleClose(done) {
      done();
    },
    goTo(path) {
      this.$router.push(path);
    },
    gotoCourse(id) {
      if (this.classList.length) {
        this.goTo(
          "/studyStudentNT?type=0&courseId=" +
          this.id +
          "&userid=" +
          this.userid +
          "&oid=" +
          this.oid +
          "&org=" +
          this.org +
          "&cid=" +
          this.classId +
          "&tType=" +
          this.tType +
          "&screenType=" +
          this.screenType +
          "&tcid=" +
          id
        );
      } else {
        this.goTo(
          "/studyStudentNT?type=0&courseId=" +
          this.id +
          "&userid=" +
          this.userid +
          "&oid=" +
          this.oid +
          "&org=" +
          this.org +
          "&cid=" +
          this.classId +
          "&tType=" +
          this.tType +
          "&screenType=" +
          this.screenType
        );
      }
    },
    addUserRate(i) {
      // var suid = this.userid;
      // if (
      //   JSON.parse(this.courseDetail.course_student).indexOf(suid) == -1 &&
      //   JSON.parse(this.courseDetail.userid) != suid
      // ) {
      //   this.$message.error("你没有该权限");
      //   return;
      // }
      // var a =
      //   this.courseDetail.course_student != ""
      //     ? JSON.parse(this.courseDetail.course_student)
      //     : "";
      // if (this.courseDetail.userid != suid) {
      //   if (this.userinfo.type == 2) {
      //     if (a != "") {
      //       if (
      //         JSON.parse(this.courseDetail.course_student).indexOf(suid) == -1
      //       ) {
      //         this.$message.error("你没有该权限");
      //         return;
      //       }
      //     } else {
      //       this.$message.error("暂无项目学员，请联系老师添加项目学员!");
      //       return;
      //     }
      //   }
      // }
      let params = {
        uid: this.userid,
        cid: this.id,
      };
      this.ajax
        .get(this.$store.state.api + "addUserR", params)
        .then((res) => {
          console.log(res.data);
          this.updateVc();
          if (this.tType == 1 || this.tType == 4) {
            this.goTo(
              "/studyStudentNT?type=" +
              i +
              "&courseId=" +
              this.id +
              "&userid=" +
              this.userid +
              "&oid=" +
              this.oid +
              "&org=" +
              this.org +
              "&cid=" +
              this.classId +
              "&tType=" +
              this.tType +
              "&screenType=" +
              this.screenType
            );
          } else if (this.tType == 2) {
            this.gotoCourse(this.classId);
          } else {
            this.goTo(
              "/study?type=" +
              i +
              "&courseId=" +
              this.id +
              "&userid=" +
              this.userid +
              "&oid=" +
              this.oid +
              "&org=" +
              this.org +
              "&cid=" +
              this.classId +
              "&tType=" +
              this.tType +
              "&screenType=" +
              this.screenType
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateVc() {
      let params = {
        cid: this.id,
      };
      this.ajax
        .get(this.$store.state.api + "updateVc", params)
        .then((res) => {
          console.log(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getCourseDetail1() {
      const loading = this.$loading.service({
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector(".student_table"),
      });
      let params = {
        courseId: this.id,
      };
       let res = await this.ajax.get(this.$store.state.api + "selectCourseDetail2", params);
      loading.close();
      // this.total = res.data[0].length > 0 ? res.data[0][0].num : 0;
      this.courseDetail = res.data[0][0];
      this.classList = res.data[3];
      var a = res.data[0];
      var b = res.data[1];
      var c = res.data[2];
      for (var i = 0; i < b.length; i++) {
        // if (!this.id) {
        //   this.courseType[b[i].id] = [];
        // }
        for (var j = 0; j < a.length; j++) {
          if (b[i].id == a[j].pid) {
            if (!this.courseTypeJson[b[i].name]) {
              this.courseType.push(b[i].name);
              this.courseTypeJson[b[i].name] = [];
            }
            this.courseTypeJson[b[i].name].push(a[j].name);
          }
        }
      }
      for (var k = 0; k < c.length; k++) {
        this.Tname.push(c[k].name);
      }
      console.log(this.courseTypeJson.length);
      this.aStudentName = res.data[2];
      this.chapInfo = JSON.parse(this.courseDetail.chapters);
      for (var z = 0; z < this.chapInfo.length; z++) {
        this.rw += this.chapInfo[z].chapterInfo[0].taskJson.length;
      }
      this.inviteCode = []
      for (var i = 0; i < res.data[4].length; i++) {
        this.inviteCode.push({ cid: res.data[4][i].classid, ic: res.data[4][i].code });
      }
      if (res.data[3].length != this.inviteCode.length) {
        let classArray = []
        let noClassArray = []
        for (var i = 0; i < res.data[3].length; i++) {
          classArray.push(res.data[3][i].id);
          noClassArray.push(res.data[3][i].id);
        }

        this.inviteCode = this.inviteCode.filter((el) => {
          if (classArray.indexOf(el.cid) != -1) {
            noClassArray.splice(noClassArray.indexOf(el.cid), 1)
            return el
          }
        })

        for (var i = 0; i < noClassArray.length; i++) {
          await this.getInviteCode(noClassArray[i])
        }
        let a = this.inviteCode
        console.log(this.inviteCode);
        this.addInviteCode();
      }
      // debugger
    },
    addInviteCode() {
      let params = [{
        courseId: this.id,
        inviteCode: JSON.stringify(this.inviteCode),
      }];
      this.ajax
        .post(this.$store.state.api + "addInviteCode", params)
        .then((res) => {
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCTwo() {
      this.type = 1;
      this.getCourseDetail2();
    },
    getCourseDetail2() {
      const loading = this.$loading.service({
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector(".student_table"),
      });
      let params = {
        courseId: this.id,
      };
      this.ajax
        .get(this.$store.state.api + "selectCourseDetail", params)
        .then((res) => {
          loading.close();
          // this.total = res.data[0].length > 0 ? res.data[0][0].num : 0;
          this.courseDetail = res.data[0][0];
          var a = res.data[0];
          var b = res.data[1];
          var c = res.data[2];
          var d = res.data[3];
          for (var i = 0; i < b.length; i++) {
            // if (!this.id) {
            //   this.courseType[b[i].id] = [];
            // }
            for (var j = 0; j < a.length; j++) {
              if (b[i].id == a[j].pid) {
                if (!this.courseTypeJson[b[i].name]) {
                  this.courseType.push(b[i].name);
                  this.courseTypeJson[b[i].name] = [];
                }
                this.courseTypeJson[b[i].name].push(a[j].name);
              }
            }
          }
          for (var k = 0; k < c.length; k++) {
            this.Tname.push(c[k].name);
          }
          console.log(this.courseTypeJson.length);
          this.aStudentName = res.data[2];
          this.chapInfo = JSON.parse(this.courseDetail.chapters);
          for (var z = 0; z < this.chapInfo.length; z++) {
            this.rw += this.chapInfo[z].chapterInfo[0].taskJson.length;
          }

          let _chapters = JSON.parse(a[0].chapters);
          let _works = res.data[3];
          let _sCont = res.data[4];
          let _comment = res.data[5];
          let _chaptersJson = {
            chapterState: _chapters,
            state: {
              stage: _chapters.length,
              finish: 0,
              learing: 0,
            },
            tool: [],
            chapter: [],
            time: {},
            startTime: _works.length ? _works[0].time : "",
            work: [],
            studentCount: _sCont[0].usercount,
          };
          let timeAarry = [];
          for (var j = 0; j < _works.length; j++) {
            timeAarry.push(_works[j].vtime);
          }
          timeAarry.forEach((item) => {
            _chaptersJson.time[item] = _chaptersJson.time[item] + 1 || 1;
          });
          for (var i = 0; i < _chapters.length; i++) {
            _chaptersJson.chapterState[i].isFinsh = false;
            // _chaptersJson.tool[i] = []
            _chaptersJson.tool[i] = { array: [], name: _chapters[i].dyName };
            _chaptersJson.chapter[i] = [];
            _chaptersJson.work[i] = {
              name: _chapters[i].dyName,
              chapter: [],
              time: "",
            };
            for (var j = 0; j < _works.length; j++) {
              if (i == _works[j].stage) {
                _chaptersJson.chapterState[i].isFinsh = true;
                _chaptersJson.work[i].time = _works[j].time;
                _chaptersJson.state.finish++;
                break;
              }
            }
            let el = _chapters[i].chapterInfo[0].taskJson;
            for (var z = 0; z < el.length; z++) {
              // _chaptersJson.tool[i][z] = [];
              _chaptersJson.tool[i].array[z] = { array: [], name: el[z].task };
              _chaptersJson.chapter[i][z] = [];
              _chaptersJson.work[i].chapter[z] = {
                name: el[z].task,
                task: [],
                isWork: false,
              };
              if (d.length > 0) {
                _chaptersJson.work[i].chapter[z].isWork = true;
              }
              _chaptersJson.work[i].is = false;
              let tools = el[z].toolChoose;
              for (var k = 0; k < tools.length; k++) {
                _chaptersJson.work[i].chapter[z].task[k] = {
                  tool: tools[k].tool[0],
                  works: [],
                  likeCount: 0,
                  commentCount: 0,
                  score: 0,
                  isScore: 0,
                };
                for (var j = 0; j < _works.length; j++) {
                  if (
                    i == _works[j].stage &&
                    z == _works[j].task &&
                    k == _works[j].tool
                  ) {
                    _chaptersJson.work[i].chapter[z].task[k].works.push(
                      _works[j]
                    );
                    if (_works[j].score) {
                      _chaptersJson.work[i].chapter[z].task[k].score +=
                        JSON.parse(_works[j].score).wScore;
                      _chaptersJson.work[i].chapter[z].task[k].isScore++;
                    }
                  }
                }
                for (var j = 0; j < _comment.length; j++) {
                  if (
                    i == _comment[j].stage &&
                    z == _comment[j].task &&
                    k == _comment[j].tool
                  ) {
                    if (_comment[j].cType == 1) {
                      _chaptersJson.work[i].chapter[z].task[k].likeCount++;
                    }

                    if (_comment[j].cType == 2) {
                      _chaptersJson.work[i].chapter[z].task[k].commentCount++;
                    }
                  }
                }
                // if (_chaptersJson.chapter[i][z].indexOf(tools[k].tool[0]) == -1) {
                //   _chaptersJson.tool[i][z].push(tools[k].tool[0])
                // }
                _chaptersJson.chapter[i][z][k] = { tool: tools[k].tool[0] };
                // _chaptersJson.tool[i][z][k] = { tool: tools[k].tool[0] };
                _chaptersJson.tool[i].array[z].array[k] = {
                  tool: tools[k].tool[0],
                };
              }
            }
          }
          _chaptersJson.state.learing =
            _chaptersJson.state.stage - _chaptersJson.state.finish;
          this.chaptersJson = _chaptersJson;
          // debugger
        })
        .catch((err) => {
          loading.close();
          console.error(err);
        });
    },
    getUser() {
      let params = { uid: this.userid };
      this.ajax
        .get(this.$store.state.api + "getUser", params)
        .then((res) => {
          this.userinfo = res.data[0][0];
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // getSName() {
    // 	let params = {
    // 		uid: JSON.stringify(this.courseDetail.course_student),
    // 	};
    // 	this.ajax
    // 		.get(this.$store.state.api + "selectSName", params)
    // 		.then((res) => {
    // 			this.aStudentName = res.data[0];
    // 		})
    // 		.catch((err) => {
    // 			console.error(err);
    // 		});
    // },
    async getInviteCode(cid) {
      let code = this.randomNumber();
      // let params = {
      //   code: code,
      //   oid: this.oid,
      // }
      // let type = 1
      // for (var i = 0; i < this.inviteCode.length; i++) {
      //   if (this.inviteCode[i].cid != cid && code == this.inviteCode[i].ic) {
      //     type = 2
      //   }
      // }
      // if (type == 2) {
      //   this.getInviteCode(cid)
      //   return;
      // }
      // const res = await this.ajax.get(this.$store.state.api + "selectInviteCode2", params)
      // if (res.data.length && res.data[0].length && res.data[0][0].courseId != this.cid) {
      //   this.getInviteCode(cid)
      //   return;
      // }

      let array = []
      for (var i = 0; i < this.inviteCode.length; i++) {
        array.push(this.inviteCode[i].cid);
      }
      if (array.indexOf(cid) != -1) {
        this.inviteCode[array.indexOf(cid)].ic = code
      } else {
        this.inviteCode.push({ cid: cid, ic: code })
      }

    },
    randomNumber() {
      // 随机生成两位数
      // let num = Math.floor(Math.random() * 900) + 100;
      // 生成 0 到 99 之间的随机整数
      const randomNumber = Math.floor(Math.random() * 100);

      // 如果随机数小于 10，补上前导零
      const num = randomNumber < 10 ? "0" + randomNumber : randomNumber.toString();

      // 随机生成两个大写字母
      let letters = '';
      let chars2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
      for (let i = 0; i < 3; i++) {
        letters += chars2.charAt(Math.floor(Math.random() * chars2.length));
      }

      // 随机生成两位数字和字母的组合
      let mix = '';
      let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (let i = 0; i < 3; i++) {
        let char = chars.charAt(Math.floor(Math.random() * chars.length));
        mix += char;
      }

      // 随机选择一种类型
      let type = Math.floor(Math.random() * 3);


      return num;
      // 根据类型输出结果
      switch (type) {
        case 0:
          console.log(num); // 输出两位数
          return num;
        case 1:
          console.log(letters); // 输出两个大写字母
          return letters;
        case 2:
          console.log(mix); // 输出两位数字和字母的组合
          return mix;
      }
    }
  },
  created() {
    // if(this.tType == 1 || this.tType == 4){
    //   this.getCourseDetail2();
    // }else{
    //   this.getCourseDetail1();
    // }
    this.getCourseDetail1();
    this.getUser();
    document.scrollingElement.scrollTop = 0;
    // this.getSName();
  },
};
</script>

<style scoped>
@media screen and (max-width: 1024px) {
  /* .Tname {
    width: 500px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  } */
}

.body_student {
  margin: 10px auto;
  width: 98%;
  height: 100%;
}

.student_head {
  width: 100%;
  background: #fff;
  height: 30%;
  position: relative;
}

.wheel {
  width: 250px;
  max-height: 146px;
  display: flex;
  align-items: center;
}

.man {
  width: 16px;
  height: 16px;
}

.wheel>img,
.man>img {
  width: 100%;
  height: 100%;
}

.box_course {
  display: flex;
  padding: 25px 0 20px 60px;
}

.right_box {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  align-items: flex-start;
  width: calc(100% - 350px);
}

.right_box_title {
  font-size: 23px;
  max-width: calc(100% - 190px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.people {
  display: flex;
  margin-top: 20px;
}

.person {
  margin-left: 10px;
  /* line-height: 18px; */
}
.btnBox{
  display: flex;
}

.now_study {
  width: 150px;
  height: 35px;
  color: #fff;
  background: #4a9eed;
  text-align: center;
  line-height: 35px;
  border-radius: 5px;
  font-size: 13px;
  cursor: pointer;
  margin-top: 30px;
}
.now_study + .now_study{
  margin-left: 10px;
}
.choose_who {
  display: flex;
  margin: 15px 0 0 25px;
}

.who_choose {
  height: 28px;
  cursor: pointer;
}

.choose_who>div:nth-child(2) {
  margin-left: 35px;
}

.choose {
  border-bottom: 5px solid #4a9eed;
  color: #4a9eed;
}

.student_body {
  display: flex;
}

.student_body,
.right {
  width: 100%;
  margin: 10px auto;
  min-height: 688px;
}

.nav {
  margin: auto 25px;
  width: 80%;
  padding-top: 5px;
  text-indent: 25px;
}

.pic {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100%;
  justify-content: space-evenly;
}

.Img {
  /*width: 30%; */
  width: 300px;
  margin: 20px 50px;
  margin: 20px 10px;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  overflow: hidden;
}

.Img>img {
  width: 100%;
  height: 100%;
}

.student_body_one,
.right_one {
  width: 100%;
  margin: 0 auto;
  background: #fff;
  margin-top: 10px;
  min-height: 688px;
}

.student {
  width: 85%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: auto 10px;
}

.student>div {
  width: 12%;
  height: 35px;
  background: #e3759a;
  text-align: center;
  border: 1px solid #e3759a;
  border-radius: 5px;
  color: #fff;
  line-height: 35px;
  margin: 10px;
}

.dialog_change>>>.el-dialog {
  border-radius: 5px;
}

.dialog_change>>>.el-dialog__header {
  background: #303030;
  height: 36px;
  line-height: 36px;
  padding-left: 10px;
  padding: 0px 10px 0px;
}

.dialog_change>>>.el-dialog__headerbtn {
  top: 10px !important;
  right: 10px !important;
}

.dialog_change>>>.el-dialog__title {
  color: #fff;
  font-size: 14px;
  line-height: 5px;
}

.dialog_change>>>.el-dialog__body {
  background: #f5f5f5;
}

.blue_box {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.blue_box,
.blue_box_one {
  width: 30%;
  height: 100px;
  text-align: center;
  color: #fff;
  background-image: linear-gradient(90deg, #477cd7, #65b9fc);
  border-radius: 15px;
  margin: 15px 0 15px 15px;
  cursor: pointer;
}

.blue_box_one {
  width: 200px;
  height: 200px;
  background-image: linear-gradient(90deg, #477cd7, #65b9fc);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}

.blue_box_one>div {
  margin: 5px 0;
}

.blue_box_one>div:nth-child(1) {
  font-size: 20px;
  font-weight: bold;
}

.blue_box>div:nth-child(2) {
  margin-top: 10px;
}

.blue_box_one>div:nth-child(2) {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  width: 100%;
  text-align: center;
  max-width: calc(100% - 85px);
  margin: 0 auto;
}

.return {
  background: #205cc6;
  width: 70px;
  height: 30px;
  color: #fff;
  text-align: center;
  line-height: 32px;
  margin-right: 20px;
  cursor: pointer;
  border-radius: 5px;
  position: absolute;
  right: 0;
  top: 24px;
  font-size: 14px;
}

.return>img {
  width: 100%;
  height: 100%;
}

.cType {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.cType>div>span {
  font-size: 18px;
}

.type_children+.type_children {
  margin-left: 10px;
}

.all_choose {
  margin-right: 10px;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rightT {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  width: calc(100% - 20px);
}

.jd {
  background: #4a9eed;
  margin-left: 15px;
  border-radius: 10px;
  color: #fff;
  width: 70px;
  height: 25px;
  text-align: center;
  line-height: 25px;
}

.sLeft {
  width: 14%;
  margin-right: 10px;
  background: rgb(255, 255, 255);
  padding: 20px 15px 0 15px;
  box-sizing: border-box;
  border-radius: 10px;
}

.courseT {
  border-left: 3px solid #2e66c9;
  padding-left: 5px;
  color: #2e66c9;
  font-weight: bold;
}

.courseTd {
  padding-top: 15px;
  height: 700px;
  overflow: auto;
  word-break: break-word;
}

.courseTd::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 6px;
}

/*定义滚动条轨道 内阴影+圆角*/
.courseTd::-webkit-scrollbar {
  border-radius: 10px;
  background-color: #eee;
}

/*定义滑块 内阴影+圆角*/
.courseTd::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

.rightTd,
.noBRight {
  width: calc(100% - 14% - 10px);
  background: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: center;
  justify-content: flex-start;
}

.noBRight {
  width: 100%;
}

.Tname {
  margin-left: 40px;
  word-break: break-all;
  width: auto;
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}

/* .TnameC{
  width:auto;
  overflow: unset;
  white-space: unset;
  text-overflow: unset;
} */

.Tname>span {
  cursor: pointer;
  color: #1463eb;
  margin-left: 10px;
}

.detail {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}

.statebox {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 30px;
}

.statebox div {
  padding: 10px 20px;
  border-radius: 5px;
  background: #fff;
  display: flex;
  align-items: center;
}

.statebox div+div {
  margin-left: 20px;
}

.statebox div span {
  font-size: 16px;
  display: flex;
  align-items: center;
}

.statebox div span+span {
  margin-left: 10px;
  color: #1463eb;
}

.p_tool_box {
  display: flex;
  flex-wrap: wrap;
  background: rgb(217, 227, 239);
  /* color: #fff; */
  padding: 0 15px 10px;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 5px;
  height: 200px;
  overflow: auto;
  max-width: 150px;
}

.p_tool {
  display: flex;
  margin-top: 10px;
}

.p_tool>div {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
}

.p_tool>div img {
  width: 50px;
  height: 50px;
}

.p_tool>div>div {
  margin-top: 5px;
  font-size: 12px;
}

.p_tool_box2 {
  padding: 10px 15px;
}

.p_tool2 {
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* margin-bottom: 10px; */
}

.p_tool2>div:nth-child(1) {
  margin-bottom: 10px;
}

.toolBigBox {
  display: flex;
  flex-direction: column;
}

.toolSta {
  display: flex;
  margin: 20px 0 0;
}

.toolSta>div {
  display: flex;
}

.toolSta>div+div {
  margin-left: 50px;
}

.toolSta>div>div:nth-child(1) {
  margin: 10px 10px 0 0;
}

.blueBtn {
  background: rgb(79, 140, 223);
  color: #fff;
  display: flex;
  padding: 10px 15px;
  /* min-width: 150px; */
  min-width: 165px;
  font-size: 16px;
  align-items: center;
  border-radius: 5px;
}

.toolSta>div>div:nth-child(2)>div+div {
  margin-top: 10px;
}

.toolSta>div>div:nth-child(2)>div>div+div {
  margin: 0 20px;
}

.p_tool2 .toolbox {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.p_tool2 .toolbox>div {
  font-size: 16px;
  font-weight: bold;
}

.checkBox {
  display: flex;
  padding: 20px 0 0 20px;
  box-sizing: border-box;
  width: 100%;
}

.checkBox span {
  padding: 0 10px 5px;
  cursor: pointer;
  font-size: 18px;
}

.checkBox span+span {
  margin-left: 20px;
}

.checkBox .active {
  border-bottom: 2px solid rgb(75, 151, 229);
  cursor: pointer;
}

.detail_box {
  background-color: rgb(231, 240, 247);
  padding: 15px 20px;
  box-sizing: border-box;
  width: 100%;
}

.detail_box+.detail_box {
  margin-top: 20px;
}

.detail_box .title {
  display: flex;
  align-items: center;
}

.detail_box .title>span:nth-child(1) {
  font-size: 20px;
  display: flex;
  align-items: center;
}

.detail_box .box {
  margin-top: 20px;
  background-color: #fff;
  padding: 15px 20px;
  border-radius: 5px;
  /* width: 100%; */
  box-sizing: border-box;
  overflow: auto;
}

.progress {
  display: -webkit-box;
  display: -ms-flexbox;
  width: 100%;
  overflow: auto;
  padding: 15px 0;
}

.chapter {
  margin-right: 30px;
  min-width: 180px;
}

.chapter+.chapter {
  padding-left: 10px;
  border-left: 1px solid rgb(220, 220, 220);
}

.chapter .stage {
  width: 100%;
  color: #fff;
  background: linear-gradient(90deg, #477cd7, #65b9fc);
  border-radius: 5px;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  text-align: center;
  min-width: 180px;
}

.chapter .task {
  display: flex;
  width: 100%;
  min-width: 180px;
}

.chapter .task .taskBox {
  min-width: 180px;
  height: 100%;
}

.chapter .task .taskBox+.taskBox {
  margin-left: 10px;
}

.chapter .task .taskBox .taskName {
  text-align: center;
  margin: 10px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  min-width: 180px;
  width: 100%;
}

.toolIcon::before {
  content: "";
  width: 26px;
  height: 26px;
  display: inline-block;
  background-image: url(../../assets/icon/toolion.png);
  background-size: 100% 100%;
}

.toolIcon::before {
  content: "";
  width: 26px;
  height: 26px;
  display: inline-block;
  background-image: url(../../assets/icon/toolion.png);
  background-size: 100% 100%;
}

.taskIcon::before {
  content: "";
  width: 26px;
  height: 26px;
  display: inline-block;
  background-image: url(../../assets/icon/task.png);
  background-size: 100% 100%;
}

.finishIcon::before {
  content: "";
  width: 26px;
  height: 26px;
  display: inline-block;
  background-image: url(../../assets/icon/finish.png);
  background-size: 100% 100%;
}

.learningIcon::before {
  content: "";
  width: 22px;
  height: 22px;
  display: inline-block;
  background-image: url(../../assets/icon/learning.png);
  background-size: 100% 100%;
}

.frequencyIcon::before {
  content: "";
  width: 26px;
  height: 26px;
  display: inline-block;
  background-image: url(../../assets/icon/frequency.png);
  background-size: 100% 100%;
}

.timeIcon::before {
  content: "";
  width: 26px;
  height: 26px;
  display: inline-block;
  background-image: url(../../assets/icon/time.png);
  background-size: 100% 100%;
}

.chapter_time_box {
  border-left: 5px solid #f0f0f0;
  padding: 0 30px;
  box-sizing: border-box;
  margin-top: 35px;
}

.c_box {
  padding-top: 40px;
  position: relative;
  margin-top: 45px;
}

.c_box .stage_box {
  display: flex;
  align-items: center;
  position: absolute;
  top: -20px;
  left: -45px;
}

.c_box .stage_box .yuan {
  width: 25px;
  height: 25px;
  background: rgb(244, 244, 244);
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.c_box .stage_box .yuan::before {
  content: "";
  width: 15px;
  height: 15px;
  background: rgb(59, 149, 238);
  border-radius: 25px;
}

.c_box .stage_box .stage {
  background: linear-gradient(90deg, #477cd7, #65b9fc);
  border-radius: 5px;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  color: #fff;
  width: fit-content;
  padding: 0 20px;
}

.s_up {
  cursor: pointer;
  transition: all 0.5s;
}

.s_up img {
  width: 35px;
}

.s_up2 {
  transform: rotate(90deg);
}

.lineBox {
  width: 5px;
  height: 20px;
  background-image: linear-gradient(180deg, #3c65ba, #a1c6ec);
  margin-right: 5px;
}

.disCss {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.disCss>div {
  margin: 10px 10px 0 0;
}

.titleCss {
  text-align: center;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  margin-left: 10px;
}

.navIndex {
  border-bottom: 1px solid #d7d7d7;
  padding-bottom: 5px;
  background: #96d1ff;
  width: 55px;
  min-width: 55px;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  height: 20px;
  line-height: 26px;
  font-size: 14px;
}

.stageCss {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/noTerminal/courseDetail.vue